<mat-card style="background-color: #007749;"><h3 style=" color: white;">Guardar Cambios - Debitos/Pagos</h3></mat-card>
<mat-card style="height: 120px;">
    <mat-card-content>
        <h3>¿Esta seguro que desea guardar todos los cambios realizados?</h3>
    </mat-card-content>
    <mat-card-actions>
      <div style="float: left;">
          <button mat-button class="buttontz" (click)="guardarDebitos(false)"  >Cancelar</button>
      </div>
      <div style="float: right;">
          <button mat-button class="buttontz" (click)="guardarDebitos(true)">Guardar</button>
      </div>
    </mat-card-actions>
</mat-card>



 